document.addEventListener("DOMContentLoaded", () => {
  // Select all swiper containers inside .image-carousel
  const carousels = document.querySelectorAll(".image-card-carousel .swiper");

  carousels.forEach((carousel, index) => {
    const nextEl = carousel.querySelector(".swiper-button-next");
    const prevEl = carousel.querySelector(".swiper-button-prev");
    const paginationEl = carousel.querySelector(".swiper-pagination");

    // Initialize a new Swiper instance for each container
    new Swiper(carousel, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      ...(nextEl && prevEl && {
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      }),
      ...(paginationEl && {
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      }),
      // Optional autoplay
      //autoplay: {
        //delay: 5000,
        //disableOnInteraction: false,
      //},
      autoplay: false, // Disable autoplay by default
      // Responsive breakpoints example
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
      },
    });
  });
});
